import { render, staticRenderFns } from "./couponEdit.vue?vue&type=template&id=02153643&"
import script from "./couponEdit.vue?vue&type=script&lang=js&"
export * from "./couponEdit.vue?vue&type=script&lang=js&"
import style0 from "./couponEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports